import React, { createContext, useState, useEffect } from 'react';

// Define the shape of the context value
interface NavigationContextType {
    path: string;
    navigateTo: (newPath: string) => void;
}

// Create the context with a default value of `null`
export const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export const NavigationProvider: React.FC<any> = ({ children }) => {
    const [path, setPath] = useState<string>(window.location.hash.slice(1) || "/home");

    const navigateTo = (newPath: string) => {
        setPath(newPath);
        window.location.hash = newPath; // Update the URL hash
    };

    useEffect(() => {
        const handleHashChange = () => {
            setPath(window.location.hash.slice(1)); // Update the path based on the hash
        };

        window.addEventListener("hashchange", handleHashChange);

        return () => {
            window.removeEventListener("hashchange", handleHashChange);
        };
    }, []);

    return (
        <NavigationContext.Provider value={{ path, navigateTo }}>
            {children}
        </NavigationContext.Provider>
    );
};